module.exports = __webpack_public_path__ + "static/media/icon-erase.2d620183.svg";